import React, { useState, useEffect, useRef, useCallback } from 'react';

const TestimonialsSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const intervalRef = useRef(null);

  const testimonials = [
    {
      text: "VowAuthor helped me express exactly what was in my heart. My partner cried happy tears when I read them at the altar!",
      author: "Jessica M.",
      location: "Austin, TX",
      rating: 5
    },
    {
      text: "I was so nervous about writing my vows. This service made it so easy and the result was beautiful and personal.",
      author: "David K.",
      location: "Denver, CO",
      rating: 5
    },
    {
      text: "The vows captured our love story perfectly. Everyone at the wedding commented on how touching they were.",
      author: "Amanda & Chris",
      location: "Seattle, WA",
      rating: 5
    },
    {
      text: "Worth every penny! The personalization made our ceremony so special and meaningful.",
      author: "Michelle P.",
      location: "Chicago, IL",
      rating: 5
    },
    {
      text: "I'm not a writer at all, but with VowAuthor my vows sounded like poetry. My fiancé was blown away.",
      author: "Robert T.",
      location: "Miami, FL",
      rating: 5
    },
    {
      text: "We both used VowAuthor and our vows complemented each other perfectly. Absolutely magical!",
      author: "Lauren & Jake",
      location: "Nashville, TN",
      rating: 5
    }
  ];

  const startAutoPlay = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(() => {
      setIsTransitioning(true);
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
    }, 5000);
  }, [testimonials.length]);

  useEffect(() => {
    startAutoPlay();
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [startAutoPlay]);

  useEffect(() => {
    if (isTransitioning) {
      const timer = setTimeout(() => setIsTransitioning(false), 600);
      return () => clearTimeout(timer);
    }
  }, [isTransitioning]);

  const goToSlide = (index) => {
    if (index !== currentIndex) {
      setIsTransitioning(true);
      setCurrentIndex(index);
      startAutoPlay();
    }
  };

  return (
    <div className="testimonials-slider-container">
      <div className="testimonials-slider-wrapper">
        <div 
          className="testimonials-slider"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="bi bi-star-fill"></i>
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <p className="testimonial-author">
                {testimonial.author}
                <span className="testimonial-location"> — {testimonial.location}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
      
      <div className="testimonials-dots">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`testimonial-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default TestimonialsSlider;
